import { Entity, Field } from "typegraph";

import { ID } from "common/entities/IEntity";

@Entity({one: "context_current"})
export default class TokenContext {

	@Field()
	public id: ID;

	@Field()
	public publicId: string;

	@Field()
	public name: string;

	@Field()
	public locale: string;

	@Field()
	public timeZone: string;

}



// WEBPACK FOOTER //
// ./src/core/util/session/TokenContext.ts